/**
 * Copy de los 3 bloqueos de calendario que hoy comunicamos activamente a la psicóloga (banner
 * "Bloqueada para recibir pacientes nuevos" + modal "¿Cómo funciona este bloqueo?" en
 * PsychologistProfile.tsx). Centralizado acá porque el mismo texto se usa en el badge del
 * banner y en el modal informativo, y para no repetir los nombres crudos de `reason` en más de
 * un lugar.
 *
 * "Demasiados pacientes" y "Límite de pacientes dentro de un período" quedan deliberadamente
 * afuera: no tienen ningún banner propio hoy (son bloqueos internos que la psicóloga no gestiona
 * directamente), y no se les agrega uno acá.
 */

export type CalendarBlockadeReason =
  | 'Tope de Pacientes solicitado por psicologo'
  | 'No cuenta con horarios de reprogramación'
  | 'Situaciones personales extraordinarias';

export interface CalendarBlockadeInfo {
  /** Label corto del badge naranja en el banner. */
  badgeLabel: string;
  /** Explicación general de cómo funciona este bloqueo (independiente del caso puntual). */
  howItWorks: string;
  /** Label del botón de acción para gestionarlo (varía: ir a una tab, ir a Agenda, o escribir). */
  manageLabel: string;
}

export const CALENDAR_BLOCKADE_REASONS: CalendarBlockadeReason[] = [
  'Tope de Pacientes solicitado por psicologo',
  'No cuenta con horarios de reprogramación',
  'Situaciones personales extraordinarias',
];

export const CALENDAR_BLOCKADE_INFO: Record<CalendarBlockadeReason, CalendarBlockadeInfo> = {
  'Tope de Pacientes solicitado por psicologo': {
    badgeLabel: 'Tope de pacientes solicitado por vos',
    howItWorks:
      'Vos nos pediste atender a un número máximo de procesos menor a nuestro tope general. Mientras estés en ese límite, no te asignamos pacientes nuevos — los procesos que ya atendés no se ven afectados de ninguna forma.',
    manageLabel: 'Ir a Sobre tu atención',
  },
  'No cuenta con horarios de reprogramación': {
    badgeLabel: 'Sin horarios de reprogramación',
    howItWorks:
      'Necesitamos que siempre tengas al menos 4 horarios de reprogramación libres (sin ocupar) en los próximos 7 días — son los que un paciente puede usar si necesita mover una sesión ya agendada. En el momento en que dejás de tener esos 4 horarios libres, te bloqueamos automáticamente para pacientes nuevos; los procesos que ya tenés no se ven afectados. Es 100% automático: se resuelve solo en cuanto vuelvas a tener esos 4 horarios libres, no hace falta escribirle a nadie.',
    manageLabel: 'Ir a mi Agenda',
  },
  'Situaciones personales extraordinarias': {
    badgeLabel: 'Situación personal',
    howItWorks:
      'Bloqueo manual para cualquier situación personal que implique dejar de recibir pacientes nuevos por un tiempo, sin una fecha de reincorporación programada todavía. Tus pacientes ya asignados siguen atendiéndose con normalidad. Escribinos cuando quieras retomar — el equipo lo desactiva manualmente y te confirma.',
    manageLabel: 'Escribirnos',
  },
};
